import { Box, Typography } from "@mui/material";
import React from "react";

interface TagStatusProps {
  variant: "green";
  icon?: React.ReactElement;
  children: React.ReactNode;
}

export const TagStatus = (props: TagStatusProps) => {
  const variantColors = {
    green: {
      background: "#BFF4BE",
      color: "#185A17",
    },
  };

  const colors = variantColors[props.variant];

  return (
    <Box
      sx={{
        display: "inline-flex",
        alignItems: "center",
        gap: 0.5,
        backgroundColor: colors.background,
        color: colors.color,
        borderRadius: "8px",
        padding: "4px 12px",
        fontSize: "14px",
        fontWeight: 500,
        lineHeight: "16px",
        whiteSpace: "nowrap",
      }}
    >
      {props.icon && (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: "16px",
            height: "16px",
            "& svg": {
              width: "16px",
              height: "16px",
              fill: "currentColor",
            },
          }}
        >
          {props.icon}
        </Box>
      )}
      <Typography
        component="span"
        sx={{
          fontSize: "inherit",
          fontWeight: "inherit",
          lineHeight: "inherit",
          color: "inherit",
        }}
      >
        {props.children}
      </Typography>
    </Box>
  );
};
